import { makeAutoObservable } from "mobx";
import agent from "../services/Api/agent";
import { DataRow, DataTableDto, IDataForm } from "../models/Pharse2/Data";
import DataForm from "../pages/Data/DataForm";
import { Dict } from "../models/Pharse2/Graph";
import { useStore } from './store';
import { LocationPairDateTimeScriptTable } from "../components/FormElement/MultiLevelSelectElement/MultiLevelSelectElement";
import postProcessingScript from "../services/Data/PostProcessingScript";
import { IZoneForm } from "../models/Phase3/Zone";

export default class ZoneStore {
	Data: DataTableDto | undefined = undefined
	loadingInitial: boolean = false
	constructor() {
		makeAutoObservable(this)
	}
	getsourceTypeList = async (locationIds: number) => {
		try {
			const sourceTypes = await agent.Graph.sourceTypeList(locationIds)
			return sourceTypes;
		} catch (error) {
			console.log(error)
		}
	}
	clientSetData = async (data: DataTableDto) => {
		this.Data = data;
	}
	getZone = async (zoneForm: IZoneForm) => {
		try {
			this.loadingInitial = true
			const result = await agent.Zone.getZone(zoneForm.locationId)
			this.loadingInitial = false
			return result;
		} catch (error) {
			this.loadingInitial = false

			console.log(error)
		}
	}

}